import { render, staticRenderFns } from "./allEntry.vue?vue&type=template&id=0485f8d5&scoped=true"
import script from "./allEntry.vue?vue&type=script&lang=js"
export * from "./allEntry.vue?vue&type=script&lang=js"
import style0 from "./allEntry.vue?vue&type=style&index=0&id=0485f8d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0485f8d5",
  null
  
)

export default component.exports